/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsTaggedImageViewProps } from './hosports-tagged-image';

export default (props: IHosportsTaggedImageViewProps) => {
    return (
        <div className='row'>
            <h2>{'Tagged Image'}</h2>
        </div>
    );
};
